import StepGrantAccess from './StepGrantAccess.component';

export default StepGrantAccess;
